//首页
import React, { useEffect, useState } from 'react'
import { Card ,Col, Row,Image,Divider,Carousel,Button} from 'antd'

import './index.css'

import {Link} from 'react-router-dom'
import { DEFAULT_SITE_NAVIGATION, fetchSiteNavigation, homeNavigationItems } from '../../siteNavigation';
import { resolveNewsImage } from '../../newsImages';
import {
  RightSquareTwoTone
} from '@ant-design/icons';
export default function Home() {
  const [homeNews, setHomeNews] = useState([]);
  const [navigation, setNavigation] = useState(DEFAULT_SITE_NAVIGATION);

  useEffect(() => {
    let cancelled = false;
    fetch('./api/home_news.php', { cache: 'no-store' })
      .then((res) => (res.ok ? res.json() : Promise.reject(new Error('home news api failed'))))
      .then((data) => {
        if (!cancelled && Array.isArray(data.rows) && data.rows.length > 0) {
          setHomeNews(data.rows.slice(0, 1));
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    let cancelled = false;
    fetchSiteNavigation()
      .then((data) => {
        if (!cancelled) setNavigation(data);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  const renderLinks = (items) =>
    homeNavigationItems(items).map((item) => (
      <React.Fragment key={`${item.label}-${item.url}`}>
        <a href={item.url}><Button type="link" icon={<RightSquareTwoTone />}/>{item.label}</a>
        <br/>
      </React.Fragment>
    ));

  const renderNewsBody = (item) => {
    const body = item.content || item.summary || '';
    if (/<[a-z][\s\S]*>/i.test(body)) {
      return <div dangerouslySetInnerHTML={{ __html: body }} />;
    }
    return body.split(/\n+/).filter(Boolean).map((line) => (
      <p key={line}>{line}</p>
    ));
  };

  const renderNewsDetailLink = (item) => {
    const enabled = Number(item?.has_detail_page) === 1 || item?.has_detail_page === true;
    if (!enabled) return null;
    const detailUrl = String(item.detail_url || '').trim();
    if (!detailUrl) return null;
    const localPath = detailUrl.startsWith('#/') ? detailUrl.slice(1) : detailUrl;
    const button = <Button type="primary" icon={<RightSquareTwoTone />}>SEE MORE</Button>;
    if (localPath.startsWith('/')) {
      return <Link to={localPath}>{button}</Link>;
    }
    return <a href={detailUrl}>{button}</a>;
  };

  const conferenceLinks = [
    ...homeNavigationItems(navigation.current_conferences),
    ...homeNavigationItems(navigation.past_conferences),
  ];

  return (
    <Card type="ncenter" >
      <Row>
        <Col span={24} offset={0}>
        <Carousel
        effect="fade" autoplay dots={false}>

        <div>
        <Link to="/about">
        <Image
        preview={false}
        className="home-carousel-image"
        src={require('../../imgs/home1-small.webp')}
        />
          </Link>
        </div>
        
        <div>
        <Link to="/membership">
        <Image
        preview={false}
        className="home-carousel-image"
        src={require('../../imgs/home2-small.webp')}
        />
            </Link>
        </div>
       {/* <div>
        <a href="https://agist.org/iccsi2024/">
        <Image
        preview={false}
        width={1200}
        height={389}
              src={require('../../imgs/home3.jpg')}
            />
            </a>
  </div>*/}
        
        </Carousel>

        </Col>
        {/*
        <Col span={7} offset={0}>
        <Card style={{ height: '500px' }}bodyStyle={{ fontSize: '20px' }} type="inner" title={<div style={{ textAlign: 'center', fontSize: '20px' }}>AGIST Highlights</div>}>
        <br/>
          <Row align='middle'>
            <Col span={8}><Image
            preview={false}
            width={80}
            height={80}
            src={require('../../imgs/earth.jpeg')}
            />
            </Col>
            <Col align='middle' span={16}>
            DIVERSE BOARD OF GOVERNORS FROM ACROSS THE GLOB
            </Col>
          </Row>
          <br/>
          <Row align='middle'>
            <Col span={8}><Image
            preview={false}
            width={80}
            height={80}
            src={require('../../imgs/member.jpg')}
            />
            </Col>
            <Col align='middle' span={16}>
            73 MEMBERSHIP AROUND THE WORLD
            </Col>
          </Row>
          <br/>
          <Row align='middle'>
            <Col span={8}><Image
            preview={false}
            width={80}
            height={80}
            src={require('../../imgs/pub.jpg')}
            />
            </Col>
            <Col align='middle' span={16}>
            MANY ARTICLES PUBLISHED IN 2021 AND 2022
            </Col>
          </Row>
        
        
        </Card>
        </Col>
        */}
      </Row>
      <Divider />
      <Row gutter={[16, 16]}>
      <Col xs={24} md={8}>
        <Card title={<div style={{ textAlign: 'center', fontSize: '20px' }}>{navigation.conference_menu_title}</div>}>
        <Image
        preview={false}
        className="home-card-image"
              src={require('../../imgs/2-small.webp')}
        />
          {renderLinks(conferenceLinks)}
        </Card>
      </Col>
      <Col xs={24} md={8}>
        <Card title={<div style={{ textAlign: 'center', fontSize: '20px' }}>{navigation.workshops_title}</div>}>
        <Image
        preview={false}
        className="home-card-image"
              src={require('../../imgs/3-small.webp')}
        />
          <br/>
          {renderLinks(navigation.workshops)}
        </Card>
        
      </Col>
      <Col xs={24} md={8}>
        <Card title={<div style={{ textAlign: 'center', fontSize: '20px' }}>{navigation.publications_title}</div>}>
        <Image
        preview={false}
        className="home-card-image"
              src={require('../../imgs/4-small.webp')}
        />
          {renderLinks(navigation.publications)}
        </Card>
      </Col>
    </Row>
          <Divider />
      {homeNews.length > 0 && (
        homeNews.map((item) => {
          const coverImage = resolveNewsImage(item.cover_image);
          return (
            <Card key={item.id || item.slug} style={{ marginTop: 16}}
              type="inner" title={<div style={{ textAlign: 'center', fontSize: '20px' }}>{item.title}</div>}>
              <Row align='middle' gutter={[16, 16]}>
                <Col align='justify' xs={24} md={coverImage ? 14 : 24}>
                {renderNewsBody(item)}
                {renderNewsDetailLink(item)}
                </Col>
                {coverImage && (
                  <Col align='justify' xs={24} md={10}>
                    <Image preview={false} className="home-card-image" src={coverImage} />
                  </Col>
                )}
              </Row>
            </Card>
          );
        })
      )}

  </Card>

  )
    
  
}
